import { atom } from "recoil";
import atomKeys from "configs/atoms";

const initState = {
    Username: ""
};

const rhpLinkAccountAtom = atom({
    key: atomKeys.Account.RHPLinkAccount,
    default: initState
});

export default rhpLinkAccountAtom;